/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBbsCategoryTreeRespVo
 */
export interface GetBbsCategoryTreeRespVo {
    /**
     * 分类编号
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    id?: number;
    /**
     * 分类名称
     * @type {string}
     * @memberof GetBbsCategoryTreeRespVo
     */
    name?: string;
    /**
     * 父级分类编号
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    parentId?: number;
    /**
     * 分类级别
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    level?: number;
    /**
     * 是否只有登录后可见  0 不是 1 是
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    onlyLoginIn?: number;
    /**
     * 分类排序
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    sort?: number;
    /**
     * 员工id
     * @type {number}
     * @memberof GetBbsCategoryTreeRespVo
     */
    staffId?: number;
    /**
     * 子级分类
     * @type {Array<GetBbsCategoryTreeRespVo>}
     * @memberof GetBbsCategoryTreeRespVo
     */
    children?: Array<GetBbsCategoryTreeRespVo>;
}

/**
 * Check if a given object implements the GetBbsCategoryTreeRespVo interface.
 */
export function instanceOfGetBbsCategoryTreeRespVo(value: object): value is GetBbsCategoryTreeRespVo {
    return true;
}

export function GetBbsCategoryTreeRespVoFromJSON(json: any): GetBbsCategoryTreeRespVo {
    return GetBbsCategoryTreeRespVoFromJSONTyped(json, false);
}

export function GetBbsCategoryTreeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBbsCategoryTreeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'level': json['level'] == null ? undefined : json['level'],
        'onlyLoginIn': json['onlyLoginIn'] == null ? undefined : json['onlyLoginIn'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(GetBbsCategoryTreeRespVoFromJSON)),
    };
}

export function GetBbsCategoryTreeRespVoToJSON(json: any): GetBbsCategoryTreeRespVo {
    return GetBbsCategoryTreeRespVoToJSONTyped(json, false);
}

export function GetBbsCategoryTreeRespVoToJSONTyped(value?: GetBbsCategoryTreeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'parentId': value['parentId'],
        'level': value['level'],
        'onlyLoginIn': value['onlyLoginIn'],
        'sort': value['sort'],
        'staffId': value['staffId'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(GetBbsCategoryTreeRespVoToJSON)),
    };
}

